function buildExploreCard(){
  $('.explore-card').addClass('display')
}

export {
  buildExploreCard
}